var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEdit = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.232,
    height: 29.218,
    viewBox: "0 0 29.232 29.218",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.698 -7.277)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.98,22.293a1.242,1.242,0,0,0-1.242,1.242V32.3H11.012V13.558h7.493a1.249,1.249,0,1,0,0-2.5H9.742A1.242,1.242,0,0,0,8.5,12.3V33.51a1.242,1.242,0,0,0,1.242,1.242H30.98a1.242,1.242,0,0,0,1.242-1.242V23.534A1.242,1.242,0,0,0,30.98,22.293Z",
    transform: "translate(5.198 1.743)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.766,12.9,29.479,7.647a1.242,1.242,0,0,0-1.767,0L15.485,19.916a1.242,1.242,0,0,0-.351.687l-.979,6.252a1.242,1.242,0,0,0,1.227,1.461h.19l6.281-.993a1.242,1.242,0,0,0,.687-.351L34.766,14.7a1.242,1.242,0,0,0,0-1.767ZM21.051,24.882l-4.192.672.643-4.163,7.669-7.7L28.675,17.2Zm9.421-9.451-3.506-3.506L28.544,10.3l3.52,3.491Z",
    transform: "translate(7.795 0)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.302f160d.svg";
export { ForwardRef as ReactComponent };